import BaseAxiosInstance from 'libs/axios/BaseAxiosInstance'
import appConfig from 'constants/appConfig'

export const postContactForm = data =>
	BaseAxiosInstance.post(appConfig.apiPrefix + '/contact-us', data)
